import { getEnvironmentFromHostname } from "./apiConfig";

const SILENT_ENVIRONMENTS = ["labs", "production"];

function isSilent(): boolean {
  return SILENT_ENVIRONMENTS.includes(getEnvironmentFromHostname());
}

// `debug` is for iProov, not us — iProovSupport's videoInput test calls it and hangs
// check() if it's missing (VEX-7881).
export const logger = {
  log:   (...args: unknown[]): void => { if (!isSilent()) console.log(...args); },
  debug: (...args: unknown[]): void => { if (!isSilent()) console.debug(...args); },
  warn:  (...args: unknown[]): void => { if (!isSilent()) console.warn(...args); },
  error: (...args: unknown[]): void => { if (!isSilent()) console.error(...args); },
};
